import { useEffect } from 'react';

function RedirectPayment() {
  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const pathname = currentUrl.pathname; // /payment-linking-process/SHOPEE
    const search = currentUrl.search;     // ?authCode=123

    // Buat URL tujuan custom scheme
    const targetUrl = `famigo:/${pathname}${search}`;

    // Redirect ke URL tersebut
    window.location.href = targetUrl;
  }, []);

  return (
    <div></div>
  );
}

export default RedirectPayment;
